import { combineReducers } from 'redux';
import listWidget from './players/listWidget';

export default combineReducers({
    listWidget
});



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/players.js